var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from "react";
import { PeekGrid, PeekInput, PeekInputAdornment, PeekTypography } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { LayoutSize, LayoutSizeDimensions } from "./SpaceEmbedCodeFormConfig";
const PX = () => (React.createElement(PeekInputAdornment, { color: "primary", position: "start" },
    React.createElement(PeekTypography, { align: "center", variant: "body2" }, "px")));
const EmbedCodeDimensions = (_a) => {
    var { field } = _a, props = __rest(_a, ["field"]);
    const intl = useIntl();
    const { form: { values: { layoutSize }, }, } = props;
    useEffect(() => {
        //@ts-ignore
        props.form.setFieldValue(field.name, LayoutSizeDimensions[layoutSize]);
    }, [layoutSize]);
    const disabled = layoutSize !== LayoutSize.C;
    return (React.createElement(PeekGrid, { container: true, columnSpacing: 1, direction: "row" },
        React.createElement(PeekGrid, { item: true, xs: 6 },
            React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: field.value.width, name: "dimensions.width" }), disabled: disabled, InputProps: {
                    endAdornment: React.createElement(PX, null),
                }, inputProps: {
                    min: "300",
                }, type: "number" }, props, { label: intl.formatMessage(messages.spaceEmbedCodeFormDimensionWidth) }))),
        React.createElement(PeekGrid, { item: true, xs: 6 },
            React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: field.value.height, name: "dimensions.height" }), disabled: disabled, InputProps: {
                    endAdornment: React.createElement(PX, null),
                }, inputProps: {
                    min: "300",
                }, type: "number" }, props, { label: intl.formatMessage(messages.spaceEmbedCodeFormDimensionHeight) })))));
};
export default EmbedCodeDimensions;
